jQuery(function($){
  var windowWidth = $(window).outerWidth();
	var windowHeight = $(window).outerHeight();

  function init(){
    lazyLoad();
    scaleBgImages();
    runWaypoints();
    // setupMegaDropdowns();
    // setupSliders();

    $(window).resize(function(){
      runResize();
    });
  }

  var runResize = function(){
		windowWidth = $(window).outerWidth();
		windowHeight = $(window).outerHeight();
  }

    function lazyLoad() {
        $('.lazy').Lazy({
            // your configuration goes here
            scrollDirection: 'vertical',
            threshold: 100,
            afterLoad: function(element) {
                scaleBgImages()
            },
            onError: function(element) {
                console.log('error loading ' + element.data('src'));
            }
        });
    }

    var links = document.links;
    for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
        if (links[i].hostname !== window.location.hostname) {
            links[i].target = '_blank';
        }
    }

    function scaleBgImages() {
        var bgs = $('*[data-bgratio]');
        bgs.each(function(){
            var _ = $(this);
            var w = _.width();
            var r = _.data('bgratio');
            _.stop().height(w * r);
            $(window).resize(function(){
                setTimeout(function(){
                    w = _.stop().width();
                }, 500);
                setTimeout(function(){
                    _.stop().height(w * r);
                },600);
            });
        });
    }

    $('#account-dropdown').click(function(){
        $(this).find('.account-sub-menu').fadeToggle();
    });

    var runWaypoints = function(){
      var waypoints = $('#waypoint').waypoint(function(direction) {
        $('#shopify-section-header, body').toggleClass('lock_nav');
      });
    }

    function setupMegaDropdowns() {
        var drops = $('.site-nav .has-dropdown .dropdown');

        drops.each(function(){
            console.log($(this));
        });
    }

    function runSliders(slider) {
        slider.slick({
            dots: true,
            arrows: false,
            slidesToShow: 1,
            slidesToScroll: 1           
        });
    }

    function setupSliders() {
        var sliderTrigger = $('.has-dropdown');

        sliderTrigger.mouseenter(function(){
           var slider = $(this).find($('.dropdown-slider'));
           runSliders(slider);
        })
    }

    init();
});